import React, { useContext } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import { DeviceContext } from '@vyce/core/src/contexts/deviceContext';
import { useStyles } from '@vyce/core/src/views/hiring/styles';

import { ButtonTitleWithLoading } from '../../../components/ButtonTitleWithLoading';
import { MAIN_CONTAINER_ID } from '../../../constants';

interface Props {
  open: boolean;
  loading: boolean;
  setOpen: Function;
  cancelConnection: () => void;
}

export const CancelConnectionDialog: React.FC<Props> = ({ open, setOpen, cancelConnection, loading }) => {
  const classes = useStyles();
  const { isMobile } = useContext(DeviceContext);

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">Are you sure you want to cancel connection?</DialogTitle>
      <DialogContent />
      <DialogActions>
        <Button size="large" variant="outlined" onClick={() => setOpen(false)}>
          No, take me back
        </Button>
        <Button
          size="large"
          style={{ width: 179 }}
          className={classes.redButton}
          onClick={cancelConnection}
          variant="outlined"
        >
          <ButtonTitleWithLoading title="Yes, I want to cancel" loaderVariant="primary" loading={loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
